'use strict';

import { RESPONSE_STATUSES } from '../modules/shared/constants/RESPONSE_STATUSES';
import { clearUserInfo, updateUserInfo } from '../modules/shared/utils/userInfoUtils';
import { CUSTOM_HEADERS } from '../modules/shared/constants/customHeaders';
import { getFormattedCurrentDateTime } from '../modules/shared/utils/dateUtils';

const { SESSION_EXIST } = RESPONSE_STATUSES;

angular.module('app').factory('HttpRequestInterceptor', HttpRequestInterceptor);

HttpRequestInterceptor.$inject = ['$q', '$location', '$injector','localStorageService', 'constants'];
// can't use utilsServices because of circular dependency
function HttpRequestInterceptor($q, $location, $injector, localStorageService, constants) {
    const { userRoles, storageKeys } = constants.enums;


    const httpRequestInterceptor = {
        request: function (config) {
            config.headers['Content-Type'] = 'application/json;charset=UTF-8';
            config.headers[CUSTOM_HEADERS.localDateTime] = getFormattedCurrentDateTime()

            if (config.url.indexOf('api/profile/avatar') >= 0 ||
                (config.url.indexOf('api/recipe') >= 0 && config.url.indexOf('api/recipes') < 0 && config.url.indexOf('api/recipe/') < 0)) {
                config.transformRequest = angular.identity;
                config.headers['Content-Type'] = undefined;
            }

            return config;
        },
        responseError: function (rejection) {
            const path = rejection.data.path ?? "";
            const errorMessage = rejection.data.message;

            switch (rejection.status) {
                case 400:
                    if (
                        !path.includes('payment-source') &&
                        !path.includes('api/coach/inbody/update')
                    ) {
                        httpRequestInterceptor.showErrorModal(errorMessage);
                    }
                    break;
                case 401:
                    httpRequestInterceptor.clearUserInfo();
                    httpRequestInterceptor.goToMainPage();

                    const isSingInRequest = path.includes('api/cookie-login');

                    if (isSingInRequest && errorMessage !== 'User not found') {
                        httpRequestInterceptor.showErrorModal(errorMessage);
                    }

                    break;
                case 402:
                    const paymentStatus = rejection.data.reason;
                    const isEntity = httpRequestInterceptor.getIsEntityRole();
                    const billingType = httpRequestInterceptor.getBillingType();

                    const paymentAvailable = isEntity && billingType?.SELF_BILLING;

                    if (paymentStatus && paymentAvailable) {
                        httpRequestInterceptor.updateUserInfo({ entity: { selfBillingEntityPaymentStatus: paymentStatus } });
                    } else {
                        httpRequestInterceptor.clearUserInfo();
                    }

                    httpRequestInterceptor.goToMainPage(); // page interceptor will relocate to the correct page (login or process payment)
                    break;
                case 404:
                    if (path.includes('api/coach/user/goal-adjustments') || path.includes('api/corporate/cookie-login')) {
                        httpRequestInterceptor.showErrorModal(errorMessage);
                    }
                    break;
                case SESSION_EXIST:
                    break;
                case 503:
                    if (path.includes('api/coach/inbody')) {
                        if (rejection.config.method === 'GET' || rejection.config.method === 'PUT') {
                            break;
                        }
                    }
                default:
                    httpRequestInterceptor.showErrorModal(errorMessage);
            }

            return $q.reject(rejection);
        },
        showErrorModal: function (message) {
            $injector.get('ModalService').alert(message, 'Error');
        },
        clearUserInfo: function () {
            clearUserInfo()
        },
        updateUserInfo: function (userInfo) {
            updateUserInfo(userInfo);
        },
        goToMainPage: function () {
            $location.path('/').search({}).replace();
        },
        getLoggedInUserData: function () {
            return JSON.parse(localStorage.getItem(storageKeys.LOGGED_IN_USER));
        },
        getIsEntityRole: function () {
            const loggedInUserData = httpRequestInterceptor.getLoggedInUserData();

            return loggedInUserData?.role === userRoles.ADMIN;
        },
        getBillingType() {
            return localStorageService.get(storageKeys.BILLING_TYPE) || {};
        },
    };

    return httpRequestInterceptor;
}

